import { Box, Button, MenuItem, Select, Typography } from '@mui/material';
import {
  ProductOrder,
  productOrderNameMap,
} from '../../interfaces/Product/GetProductsRequest';
import { sharedColors } from '../../utils/Style';
import { useIsMobile } from '../../hooks/useIsMobile';

type SortProductsHeaderProps = {
  loading: boolean;
  totalCount: number;
  order: ProductOrder;
  onChangeOrder: (newOrder: ProductOrder) => void;
  filterCount?: number;
  onFilter?: () => void;
};

export const SortProductsHeader = ({
  loading,
  totalCount,
  order,
  onChangeOrder,
  filterCount,
  onFilter,
}: SortProductsHeaderProps) => {
  const isMobile = useIsMobile();

  const textStyle = {
    fontSize: '14px',
    fontWeight: 400,
    color: sharedColors.gray6,
  };

  const showFilterButton = isMobile && !!onFilter;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        flexWrap: 'wrap',
        backgroundColor: sharedColors.gray2,
        border: '1px solid #e1e1e1',
        p: 2,
        boxSizing: 'border-box',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography sx={textStyle}>
        {loading ? 'Ürünler yükleniyor...' : `${totalCount} ürün gösteriliyor`}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          alignItems: 'center',
          flexGrow: 1,
          justifyContent: 'end',
        }}
      >
        {!showFilterButton && (
          <Typography sx={textStyle}>Ürünleri sırala</Typography>
        )}

        <Select
          value={order}
          size='small'
          onChange={(e) => onChangeOrder(e.target.value as ProductOrder)}
          fullWidth={isMobile}
          sx={{
            fontSize: '14px',
            minWidth: 200,
          }}
        >
          {Object.entries(productOrderNameMap).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>

        {showFilterButton && (
          <Button
            variant='outlined'
            color='inherit'
            onClick={() => onFilter?.()}
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              width: 130,
              color: sharedColors.gray7,
              border: '1px solid #d1d1d1',
            }}
          >
            FİLTRE {filterCount ? `(${filterCount})` : ''}
          </Button>
        )}
      </Box>
    </Box>
  );
};
